import { useEffect } from 'react';
import { useEditSceneModalPlaybackContext } from '../EditSceneModalPlaybackContext';
import { useEditSceneModalStateContext } from '../state';

export default function useClipReady() {
  const { dispatch } = useEditSceneModalStateContext();
  const { playerRef } = useEditSceneModalPlaybackContext();

  useEffect(() => {
    const player = playerRef.current;

    if (!player) {
      return undefined;
    }

    if (player.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      dispatch({ type: 'preview-canplay' });
      return undefined;
    }

    const handleCanPlay = () => {
      dispatch({ type: 'preview-canplay' });
      player.removeEventListener('canplay', handleCanPlay);
    };

    player.addEventListener('canplay', handleCanPlay);

    return () => {
      player.removeEventListener('canplay', handleCanPlay);
    };
  }, [dispatch, playerRef]);
}
